/**
 * Utility functions to detect user setup type
 */

/**
 * Check if user has a simplified setup (only primary reader, no family)
 * @param {Array} readers - Array of reader objects
 * @param {Array} families - Array of family objects
 * @returns {boolean} - True if user has simplified setup
 */
export const hasSimplifiedSetup = (readers = [], families = []) => {
  // User has simplified setup if:
  // 1. Only has one reader (the primary reader)
  // 2. No family groups
  return readers.length === 1 && families.length === 0;
};

/**
 * Check if user has additional readers beyond the primary reader
 * @param {Array} readers - Array of reader objects
 * @returns {boolean} - True if user has additional readers
 */
export const hasAdditionalReaders = (readers = []) => {
  return readers.length > 1;
};

/**
 * Check if user has any family groups
 * @param {Array} families - Array of family objects
 * @returns {boolean} - True if user has family groups
 */
export const hasFamilyGroups = (families = []) => {
  return families.length > 0;
};

/**
 * Get the primary reader from the readers array
 * @param {Array} readers - Array of reader objects
 * @returns {Object|null} - Primary reader object or null
 */
export const getPrimaryReader = (readers = []) => {
  return readers.find(reader => reader.isPrimary) || null;
};
